import React from 'react';

import { Permission } from 'Generated/schema';
import useCustomDashboardsEnabled from 'Hooks/useCustomDashboardsEnabled';

const dashboardPermissions = [
  // Most dashboards need this permission
  Permission.SummaryRead,
  // Mitre matrix needs these permissions
  Permission.RuleRead,
  Permission.PolicyRead,
  Permission.RuleModify,
  Permission.PolicyModify,
  Permission.AlertRead,
];

const useDashboardAllowedPermissions = () => {
  const enableCustomDashboards = useCustomDashboardsEnabled();

  const dashboardAllowedPermissions = React.useMemo(() => {
    // If custom dashboards are enabled, add the DataAnalyticsRead permission
    return enableCustomDashboards
      ? [...dashboardPermissions, Permission.DataAnalyticsRead]
      : dashboardPermissions;
  }, [enableCustomDashboards]);

  return dashboardAllowedPermissions;
};

export default useDashboardAllowedPermissions;
